"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["prefix", "order", "onChange"];

function Switcher(_ref) {
  var prefix = _ref.prefix,
      order = _ref.order,
      onChange = _ref.onChange,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var handleChange = function handleChange(order) {
      onChange && onChange(order);
    };

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['part']
    }, prefix), /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": "".concat(props['data-locator'], ".created") + (order === 'created' ? '.active' : ''),
      className: (0, _classnames["default"])(_defaultModule["default"]['part'], _defaultModule["default"]['cursored'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['active'], order === 'created')),
      onClick: function onClick() {
        return handleChange('created');
      }
    }, "\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F"), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['part']
    }, "/"), /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": "".concat(props['data-locator'], ".updated") + (order === 'updated' ? '.active' : ''),
      className: (0, _classnames["default"])(_defaultModule["default"]['part'], _defaultModule["default"]['cursored'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['active'], order === 'updated')),
      onClick: function onClick() {
        return handleChange('updated');
      }
    }, "\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['part']
    }, "/"), /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": "".concat(props['data-locator'], ".both") + (order === 'both' ? '.active' : ''),
      className: (0, _classnames["default"])(_defaultModule["default"]['part'], _defaultModule["default"]['cursored'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['active'], order === 'both')),
      onClick: function onClick() {
        return handleChange('both');
      }
    }, "\u0432\u0441\u0435"));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

Switcher.defaultProps = {
  order: 'created'
};
var _default = Switcher;
exports["default"] = _default;